import React, { useState } from "react";
import { FcGoogle } from "react-icons/fc";
import MaxWidthWrapper from "../components/max-width-warpper";

const Login = ({ onGoogleSignIn, isLoading, error }) => {
  const [isSigningIn, setIsSigningIn] = useState(false);

  const handleGoogleSignIn = async () => {
    setIsSigningIn(true);
    try {
      await onGoogleSignIn();
    } catch (error) {
      console.error('Sign in failed:', error);
    } finally {
      setIsSigningIn(false);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-100">
      <MaxWidthWrapper>
        <div className="min-h-screen flex flex-col items-center justify-center px-4">
          {/* Bookmarks Title - matching dashboard style exactly */}
          <h2 className="font-bold text-[50px] w-full text-center my-10 text-zinc-500/20 select-none">
            Bookmarks
          </h2>

          {/* Login Container - matching dashboard card style */}
          <div className="w-full max-w-md bg-zinc-900/20 border border-zinc-800 border-dashed rounded-lg p-8">
            {/* Welcome Section */}
            <div className="text-center mb-8">
              <h3 className="text-xl font-medium text-zinc-300 mb-2">
                Welcome Back
              </h3>
              <p className="text-zinc-500 text-sm">
                Sign in to access your personal bookmarks
              </p>
            </div>

            {/* Error Message */}
            {error && (
              <div className="mb-6 p-3 bg-red-500/10 border border-red-500/20 rounded-md">
                <p className="text-red-400 text-sm">{error}</p>
              </div>
            )}

            {/* Google Sign In Button */}
            <button
              onClick={handleGoogleSignIn}
              disabled={isLoading || isSigningIn}
              className="w-full flex items-center justify-center gap-3 py-3 px-4 bg-white hover:bg-gray-50 text-gray-900 border border-gray-300 rounded-md transition-all duration-200 ease-in-out font-medium text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-zinc-950 disabled:opacity-70 disabled:cursor-not-allowed"
            >
              {isLoading || isSigningIn ? (
                <>
                  <div className="w-4 h-4 border-2 border-gray-300 border-t-gray-600 rounded-full animate-spin"></div>
                  <span>Signing in...</span>
                </>
              ) : (
                <>
                  <FcGoogle className="w-4 h-4" />
                  <span>Sign in with Google</span>
                </>
              )}
            </button>

            {/* Features */}
            <div className="mt-6 space-y-2">
              <div className="flex items-center text-zinc-500 text-xs">
                <svg className="w-3 h-3 mr-2 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                Secure Google authentication
              </div>
              <div className="flex items-center text-zinc-500 text-xs">
                <svg className="w-3 h-3 mr-2 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                Organize bookmarks by categories
              </div>
              <div className="flex items-center text-zinc-500 text-xs">
                <svg className="w-3 h-3 mr-2 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                Drag & drop organization
              </div>
            </div>

            {/* Footer */}
            <div className="mt-6 text-center">
              <p className="text-xs text-zinc-600">
                By signing in, you agree to our terms of service
              </p>
            </div>
          </div>
        </div>
      </MaxWidthWrapper>
    </div>
  );
};

export default Login;
